import { cn } from '@Utils/cn';
import type { AgentStatus } from '@Types/agent';

interface Props {
  status: AgentStatus;
  className?: string;
}

/**
 * Live status indicator.
 * - active  → green dot with a pulsing ring (Tailwind `animate-ping`)
 * - working → amber dot with a spinning ring (Tailwind `animate-spin`)
 * - idle    → static gray dot
 */
export default function StatusDot({ status, className }: Props) {
  return (
    <span className={cn('relative flex h-3 w-3', className)}>
      {status === 'active' && (
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-400 opacity-75" />
      )}
      {status === 'working' && (
        <span className="absolute inline-flex h-full w-full animate-spin rounded-full border-2 border-amber-400 border-t-transparent" />
      )}
      <span
        className={cn(
          'relative inline-flex h-3 w-3 rounded-full ring-2 ring-white',
          status === 'active' && 'bg-green-500',
          status === 'working' && 'bg-amber-500',
          status === 'idle' && 'bg-zinc-300',
        )}
      />
    </span>
  );
}
